import styled from "styled-components"

export const LandingBlock = styled.div`
    scroll-snap-type: mandatory;
    scroll-snap-points-y: repeat(800vh);
    scroll-snap-type: y mandatory;
`